import { Sparkles, Flame, Medal, CalendarCheck, Trophy, TrendingUp, ScanText, Lock } from "lucide-react";

const ICONS = { Sparkles, Flame, Medal, CalendarCheck, Trophy, TrendingUp, ScanText };

export default function Badges({ badges = [] }) {
    return (
        <div className="rounded-3xl border border-stone-200/80 dark:border-stone-800 bg-white/70 dark:bg-[#242322]/70 p-6" data-testid="badges-block">
            <div className="text-[11px] tracking-[0.2em] uppercase font-bold text-stone-400">Milestones</div>
            <div className="mt-5 grid grid-cols-2 sm:grid-cols-4 gap-4">
                {badges.map((b) => {
                    const Icon = ICONS[b.icon] || Sparkles;
                    const unlocked = b.unlocked;
                    return (
                        <div
                            key={b.id}
                            data-testid={`badge-${b.id}`}
                            className={`relative flex flex-col items-center text-center rounded-3xl p-4 border transition-all
                                ${unlocked
                                    ? "border-terracotta/30 bg-terracotta/5"
                                    : "border-stone-200 dark:border-stone-800 bg-stone-50/40 dark:bg-stone-900/40 opacity-70"}`}
                        >
                            <div className={`w-12 h-12 rounded-full flex items-center justify-center
                                ${unlocked ? "bg-terracotta text-white" : "bg-stone-200 dark:bg-stone-800 text-stone-400"}`}>
                                {unlocked ? <Icon size={20} strokeWidth={1.5} /> : <Lock size={16} strokeWidth={1.5} />}
                            </div>
                            <div className="font-serif text-lg leading-tight mt-2">{b.title}</div>
                            <div className="text-[11px] text-stone-500 mt-1 leading-snug">{b.tagline}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
